export const getMaskedPricing = (amount: number | string): string => {
  // Convert to string and remove commas
  const str = amount.toString().replace(/,/g, "");
  // If less than 3 digits, return as is
  if (str.length <= 3) return str;
  // Mask all but last 3 digits
  const masked = "X".repeat(str.length - 3) + str.slice(-3);
  return masked;
};
